import store from '@/store/store';
import { tryParseInt } from '@/utils/number';
import EditTeamSchedule from '@/views/team/tabs/schedule/Edit.vue';

export const editTeamScheduleRoute = {
  path: ':scheduleId/edit',
  name: 'editTeamSchedule',
  component: EditTeamSchedule,
  meta: {
    breadcrumb: {
      title: 'breadcrumbs.schedules.edit'
    }
  },
  props: { edit: true },
  beforeEnter: (to: any, from: any, next: any) => {
    store.commit('schedule/setId', tryParseInt(to.params.scheduleId));
    store
      .dispatch('schedule/get')
      .then(schedule => {
        editTeamScheduleRoute.meta.breadcrumb.title = schedule.name;
        next();
      })
      .catch(() => store.dispatch('notifyError', { title: 'messages.schedule.getError' }));
  }
};
